import { render } from "./Modules.vue?vue&type=template&id=72f21d45&scoped=true"
import script from "./Modules.vue?vue&type=script&lang=js"
export * from "./Modules.vue?vue&type=script&lang=js"

import "./Modules.vue?vue&type=style&index=0&id=72f21d45&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-72f21d45"

export default script